import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icon-plus-p.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "jr-pr-2.5",
  src: _imports_0,
  alt: "plus"
}, null, -1)
const _hoisted_2 = { class: "jr-text-xs jr-text-primary jr-font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["jr-flex", { 'jr-opacity-50 jr-pointer-events-none': _ctx.disable }])
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleTap && _ctx.handleTap(...args))),
      class: _normalizeClass(["jr-flex jr-flex-1 jr-w-full jr-justify-center jr-items-baseline jr-py-2 jr-border jr-border-primary jr-rounded hover:jr-bg-primary-light", { 'jr-bg-primary-light jr-pointer-events-none': _ctx.active }])
    }, [
      _hoisted_1,
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1)
    ], 2),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClear && _ctx.handleClear(...args))),
      class: _normalizeClass([{ 'jr-opacity-50 jr-pointer-events-none': !_ctx.active }, "jr-text-xxs jr-text-primary jr-px-3"])
    }, "クリア", 2)
  ], 2))
}